<script lang="ts" setup>
const { routeNameWithoutLocale } = useNavigation()
</script>

<template>
  <UMain class="max-w-screen relative min-h-[calc(calc(100vh-calc(var(--header-height)+1.25rem))-var(--footer-height))] pt-[calc(var(--header-height)+1.25rem)]">
    <LayoutBackground
      height="h-screen"
      image="rock"
      :opacity="routeNameWithoutLocale === 'index' ? 'dark:opacity-70' : routeNameWithoutLocale === 'api-slug' ? 'opacity-10 dark:opacity-20' : 'dark:opacity-60'"
    />

    <LayoutHeader />

    <UPage class="relative min-h-[calc(calc(100vh-calc(var(--header-height)+1.25rem))-var(--footer-height))]">
      <slot />
    </UPage>

    <LayoutFooter />
  </UMain>
</template>
